// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-97b07cba]{display:none}#cart-popup .popup__wrapper[data-v-97b07cba]{height:100%;left:0;position:absolute;top:0;width:100%;z-index:var(--z-index-modal)}#cart-popup .popup__content[data-v-97b07cba]{margin:0 auto;max-width:1200px;position:relative}#cart-popup[data-v-97b07cba] .final-popup{top:70px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
